import { useEffect } from 'react';
import { useReferenceDataStore } from '@/stores/referenceDataStore';

/**
 * Returns countries from the global store. Fetches once on first use, then serves from store.
 * Drop-in replacement for `useQuery({ queryKey: ['countries'], queryFn: ... })`.
 */
export function useCountries() {
  const countries = useReferenceDataStore((s) => s.countries);
  const isLoading = useReferenceDataStore((s) => s.countriesLoading);
  const loaded = useReferenceDataStore((s) => s.countriesLoaded);
  const error = useReferenceDataStore((s) => s.countriesError);
  const fetchCountries = useReferenceDataStore((s) => s.fetchCountries);

  useEffect(() => {
    if (!loaded && !isLoading && !error) {
      void fetchCountries();
    }
  }, [loaded, isLoading, error, fetchCountries]);

  return { countries, isLoading: isLoading && !loaded };
}
